module.exports = __webpack_public_path__ + "img/210.hand_dryer.843fd090.svg";